// extracted by mini-css-extract-plugin
export default {"PaymentsAddBankManualScreen":"PaymentsAddBankManualScreen_PaymentsAddBankManualScreen__aEZuK","Header":"PaymentsAddBankManualScreen_Header__tiC5V"};